module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "result-container"
  }, [_c('div', {
    staticClass: "container"
  }, [(_vm.showResultPart == 'check') ? _c('div', {
    staticClass: "result result-check",
    class: _vm.analyseClass
  }, [_c('div', {
    staticClass: "result__title"
  }, [_vm._v("Pourcentage de votre CA prévisionnel")]), _vm._v(" "), _c('div', {
    staticClass: "result__amount-container"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "width": _vm.svgCircleRadius * 2,
      "height": _vm.svgCircleRadius * 2,
      "viewbox": _vm.viewbox,
      "x": "0",
      "y": "0"
    }
  }, [_c('circle', {
    style: ({
      'stroke-dasharray': _vm.strokeDashArray
    }),
    attrs: {
      "r": _vm.svgCircleRadius,
      "cx": _vm.svgCircleRadius,
      "cy": _vm.svgCircleRadius
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "result__amount"
  }, [_vm._v(_vm._s(_vm.result) + " %")])]), _vm._v(" "), _c('p', {
    domProps: {
      "textContent": _vm._s(_vm.analyse)
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.showResultPart == 'calculation') ? _c('div', {
    staticClass: "result result-calculation"
  }, [_c('div', {
    staticClass: "result__title"
  }, [_vm._v("Votre budget de communication")]), _vm._v(" "), _c('div', {
    staticClass: "result__amount-container"
  }, [_c('div', {
    staticClass: "result__amount"
  }, [_vm._v(_vm._s(_vm.result) + " €")])]), _vm._v(" "), _c('p', [_vm._v("Ce montant est calculé sur une base de 6% de votre CA prévisionnel. Il peut être supérieur en cas de lancement. Un investissement inférieur à 4% ne serait pas suffisant")])]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-lg btn-primary",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("Retour")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-7c150e15!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/budget/Result.vue
// module id = 48
// module chunks = 0